/* FILOSOGNO — Atelier theme scripts */
(() => {
  const doc = document.documentElement;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  /* ---------------- Geo routing: Italy → Italian/EUR, Europe → English/EUR, rest → English/USD ---------------- */
  const Geo = {
    KEY: 'fs_loc',
    EU: ['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE','NO','IS','LI','CH','GB','MC','SM','VA','AD','AL','BA','ME','MK','RS','XK','MD','UA','GI','FO','JE','GG','IM','AX'],
    get() { const m = document.cookie.match(/(?:^|; )fs_loc=([^;]*)/); return m ? decodeURIComponent(m[1]) : null; },
    set(v) { document.cookie = `${this.KEY}=${encodeURIComponent(v)};path=/;max-age=${60 * 60 * 24 * 365};samesite=lax`; },
    target(cc) {
      if (cc === 'IT') return { country: 'IT', lang: 'it' };
      return { country: cc, lang: 'en' };
    },
    submit(country, lang) {
      const f = $('#GeoForm');
      if (!f) return;
      f.querySelector('[name="country_code"]').value = country;
      f.querySelector('[name="language_code"]').value = lang;
      f.submit();
    },
    async run() {
      if (this.get()) return;
      if (/bot|crawl|spider|slurp|lighthouse|preview|facebookexternalhit/i.test(navigator.userAgent)) return;
      if (window.Shopify && Shopify.designMode) return;
      try {
        const r = await fetch(`${root}browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true`, { credentials: 'same-origin' });
        const d = await r.json();
        let cc = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
        if (!cc && d && d.suggestions && d.suggestions[0] && d.suggestions[0].parts && d.suggestions[0].parts.country) cc = d.suggestions[0].parts.country.handle;
        if (!cc) return;
        cc = cc.toUpperCase();
        const t = this.target(cc);
        this.set(`auto:${cc}`);
        const curCountry = (window.Shopify && Shopify.country) || '';
        const curLang = ((window.Shopify && Shopify.locale) || '').slice(0, 2);
        if (curCountry !== t.country || curLang !== t.lang) this.submit(t.country, t.lang);
      } catch (e) { /* stay where we are */ }
    }
  };
  Geo.run();

  /* Manual country selector */
  $$('[data-loc-select]').forEach(sel => sel.addEventListener('change', () => {
    Geo.set('manual');
    const [country, lang] = sel.value.split('|');
    Geo.submit(country, lang);
  }));

  /* ---------------- Load state ---------------- */
  const ready = () => requestAnimationFrame(() => doc.classList.add('is-loaded'));
  if (document.fonts && document.fonts.ready) Promise.race([document.fonts.ready, new Promise(r => setTimeout(r, 900))]).then(ready); else ready();

  /* ---------------- Smooth scroll ---------------- */
  let lenis = null;
  if (!reduce && window.Lenis && !(window.Shopify && Shopify.designMode)) {
    lenis = new Lenis({ duration: 1.15, easing: t => Math.min(1, 1.001 - Math.pow(2, -10 * t)), smoothWheel: true });
    const raf = t => { lenis.raf(t); requestAnimationFrame(raf); };
    requestAnimationFrame(raf);
    window.fsLenis = lenis;
  }
  const lock = on => { document.body.classList.toggle('is-locked', on); if (lenis) on ? lenis.stop() : lenis.start(); };

  /* ---------------- Header ---------------- */
  const header = $('[data-header]');
  if (header) {
    let last = 0;
    const onScroll = () => {
      const y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 40);
      header.classList.toggle('is-hidden', y > 400 && y > last + 4 && !document.body.classList.contains('is-locked'));
      if (y < last - 4) header.classList.remove('is-hidden');
      last = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------- Announcement ---------------- */
  const ann = $$('.announce__item');
  if (ann.length > 1) {
    let i = 0;
    setInterval(() => {
      ann[i].classList.remove('is-active'); ann[i].classList.add('is-out');
      const prev = ann[i];
      setTimeout(() => prev.classList.remove('is-out'), 900);
      i = (i + 1) % ann.length;
      ann[i].classList.add('is-active');
    }, 4200);
  }

  /* ---------------- Drawers ---------------- */
  const openDrawer = id => { const d = document.getElementById(id); if (!d) return; d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); lock(true); setTimeout(() => { const f = d.querySelector('[data-autofocus]') || d.querySelector('button'); f && f.focus(); }, 300); };
  const closeDrawers = () => { $$('.drawer.is-open').forEach(d => { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); }); lock(false); };
  document.addEventListener('click', e => {
    const o = e.target.closest('[data-open]');
    if (o) { e.preventDefault(); openDrawer(o.dataset.open); return; }
    if (e.target.closest('[data-close]')) { e.preventDefault(); closeDrawers(); }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawers(); });

  /* ---------------- Accordion ---------------- */
  document.addEventListener('click', e => {
    const q = e.target.closest('.acc__q');
    if (!q) return;
    const item = q.closest('.acc__item');
    const open = !item.classList.contains('is-open');
    item.classList.toggle('is-open', open);
    q.setAttribute('aria-expanded', open);
  });

  /* ---------------- Cart (AJAX + section rendering) ---------------- */
  const Cart = {
    async refresh(open = true) {
      try {
        const r = await fetch(`${root}?sections=cart-drawer`);
        const j = await r.json();
        const html = new DOMParser().parseFromString(j['cart-drawer'], 'text/html');
        const fresh = html.querySelector('#CartDrawer');
        const cur = document.getElementById('CartDrawer');
        if (fresh && cur) {
          cur.querySelector('.drawer__panel').innerHTML = fresh.querySelector('.drawer__panel').innerHTML;
        }
        const c = await (await fetch(`${root}cart.js`)).json();
        $$('[data-cart-count]').forEach(el => {
          el.textContent = c.item_count;
          el.classList.toggle('has-items', c.item_count > 0);
          el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
        });
        if (open) openDrawer('CartDrawer');
      } catch (e) { window.location.href = `${root}cart`; }
    },
    async add(form) {
      const btn = form.querySelector('[type="submit"]');
      const label = btn && btn.querySelector('[data-label]');
      const orig = label ? label.textContent : '';
      if (btn) { btn.disabled = true; if (label) label.textContent = btn.dataset.adding || orig; }
      try {
        const r = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) });
        if (!r.ok) throw new Error('add');
        await this.refresh(true);
      } catch (e) { form.submit(); }
      finally { if (btn) { btn.disabled = false; if (label) label.textContent = orig; } }
    },
    async change(key, quantity) {
      await fetch(`${root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
      if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
      await this.refresh(false);
    }
  };
  document.addEventListener('submit', e => {
    const f = e.target.closest('form[data-ajax-cart]');
    if (!f) return;
    e.preventDefault();
    Cart.add(f);
  });
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-line-change]');
    if (!b) return;
    e.preventDefault();
    Cart.change(b.dataset.key, parseInt(b.dataset.qty, 10));
  });

  /* ---------------- Newsletter ---------------- */
  if (/[?&]customer_posted=true/.test(location.search)) {
    const n = document.getElementById('newsletter');
    n && n.scrollIntoView();
  }

  /* ---------------- Reveal on view ---------------- */
  const io = new IntersectionObserver(entries => entries.forEach(en => {
    if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
  }), { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });
  $$('[data-reveal],[data-clip],.split-lines').forEach(el => io.observe(el));

  /* ---------------- Sticky add-to-cart ---------------- */
  const mainBuy = $('[data-main-buy]');
  const sticky = $('[data-sticky-atc]');
  if (mainBuy && sticky) {
    new IntersectionObserver(([en]) => sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(mainBuy);
  }

  /* ---------------- Custom cursor ---------------- */
  const cursor = $('.cursor');
  if (cursor && window.matchMedia('(hover:hover) and (pointer:fine)').matches && !reduce) {
    let x = innerWidth / 2, y = innerHeight / 2, cx = x, cy = y;
    addEventListener('mousemove', e => { x = e.clientX; y = e.clientY; }, { passive: true });
    const loop = () => { cx += (x - cx) * .18; cy += (y - cy) * .18; cursor.style.transform = `translate3d(${cx}px,${cy}px,0)`; requestAnimationFrame(loop); };
    loop();
    document.addEventListener('mouseover', e => {
      const v = e.target.closest('[data-cursor="view"]');
      const h = e.target.closest('a,button,[data-cursor]');
      cursor.classList.toggle('is-hover', !!h);
      cursor.classList.toggle('is-view', !!v);
    });
  }

  /* ---------------- Magnetic buttons ---------------- */
  if (!reduce && window.matchMedia('(hover:hover)').matches) {
    $$('[data-magnetic]').forEach(el => {
      el.addEventListener('mousemove', e => {
        const r = el.getBoundingClientRect();
        const dx = (e.clientX - r.left - r.width / 2) * .22, dy = (e.clientY - r.top - r.height / 2) * .3;
        el.style.transform = `translate(${dx}px,${dy}px)`;
      });
      el.addEventListener('mouseleave', () => { el.style.transform = ''; });
    });
  }

  /* ---------------- Page transitions ---------------- */
  if (!reduce && !(window.Shopify && Shopify.designMode)) {
    document.addEventListener('click', e => {
      const a = e.target.closest('a');
      if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || a.target === '_blank' || a.hasAttribute('download') || a.dataset.open) return;
      const url = new URL(a.href, location.href);
      if (url.origin !== location.origin || url.hash && url.pathname === location.pathname || /\/(checkout|cart\/|account\/logout)/.test(url.pathname)) return;
      e.preventDefault();
      doc.classList.add('is-leaving');
      setTimeout(() => { location.href = a.href; }, 620);
    });
    addEventListener('pageshow', ev => { if (ev.persisted) doc.classList.remove('is-leaving'); });
  }

  /* ---------------- Scroll-linked motion (GSAP) ---------------- */
  const boot = () => {
    if (reduce || !window.gsap || !window.ScrollTrigger) {
      $$('.intro__text .w').forEach(w => w.classList.add('is-on'));
      return;
    }
    gsap.registerPlugin(ScrollTrigger);
    if (lenis) lenis.on('scroll', ScrollTrigger.update);

    /* Intro: word-by-word illumination */
    $$('.intro__text').forEach(t => {
      const words = $$('.w', t);
      ScrollTrigger.create({
        trigger: t, start: 'top 80%', end: 'bottom 45%', scrub: true,
        onUpdate: s => { const n = Math.round(s.progress * words.length); words.forEach((w, i) => w.classList.toggle('is-on', i < n)); }
      });
    });

    /* Thread SVG draws on scroll */
    $$('[data-thread] path').forEach(p => {
      const len = p.getTotalLength();
      p.style.strokeDasharray = len; p.style.strokeDashoffset = len;
      gsap.to(p, { strokeDashoffset: 0, ease: 'none', scrollTrigger: { trigger: p.closest('section'), start: 'top 75%', end: 'bottom 40%', scrub: 1 } });
    });

    /* Parallax media */
    $$('[data-parallax]').forEach(el => {
      const amt = parseFloat(el.dataset.parallax) || 10;
      gsap.fromTo(el, { yPercent: -amt }, { yPercent: amt, ease: 'none', scrollTrigger: { trigger: el.parentElement, start: 'top bottom', end: 'bottom top', scrub: true } });
    });

    /* Hero: soft zoom-out while leaving */
    const hero = $('.hero');
    if (hero) {
      gsap.to('.hero__content', { yPercent: -18, opacity: 0, ease: 'none', scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom 30%', scrub: true } });
      gsap.to('.hero__media', { scale: 1.08, ease: 'none', scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true } });
    }

    /* Method: horizontal pinned track (desktop) */
    const mm = gsap.matchMedia();
    mm.add('(min-width: 901px)', () => {
      const pin = $('.method__pin'), track = $('.method__track'), bar = $('.method__progress i');
      if (!pin || !track) return;
      const dist = () => track.scrollWidth - window.innerWidth + parseFloat(getComputedStyle(track).paddingLeft);
      const tw = gsap.to(track, { x: () => -dist(), ease: 'none', scrollTrigger: { trigger: pin, start: 'top top', end: () => `+=${dist()}`, pin: true, scrub: 1, invalidateOnRefresh: true, onUpdate: s => { if (bar) bar.style.transform = `scaleX(${s.progress})`; } } });
      $$('.step__media img', track).forEach(img => gsap.fromTo(img, { xPercent: -6 }, { xPercent: 6, ease: 'none', scrollTrigger: { trigger: img, containerAnimation: tw, start: 'left right', end: 'right left', scrub: true } }));
    });

    /* Footer wordmark letters rise */
    const fw = $('.footer__word');
    if (fw) gsap.from($$('span', fw), { yPercent: 60, opacity: 0, stagger: .05, ease: 'power3.out', duration: 1.4, scrollTrigger: { trigger: fw, start: 'top 92%' } });

    /* Gallery drift */
    $$('.gallery__item').forEach((g, i) => gsap.to(g, { y: i % 2 ? -60 : -20, ease: 'none', scrollTrigger: { trigger: g, start: 'top bottom', end: 'bottom top', scrub: true } }));

    addEventListener('load', () => ScrollTrigger.refresh());
  };
  if (document.readyState === 'complete') boot(); else addEventListener('load', boot);

  /* Hero video: play only when visible, honour data saver */
  $$('video[data-autoplay]').forEach(v => {
    const conn = navigator.connection;
    if (conn && (conn.saveData || /2g/.test(conn.effectiveType || ''))) { v.removeAttribute('autoplay'); return; }
    v.muted = true; v.playsInline = true;
    new IntersectionObserver(([en]) => en.isIntersecting ? v.play().catch(() => {}) : v.pause()).observe(v);
  });
})();
